import React, {PropsWithChildren, useEffect, useState} from 'react';
import CreatableSelect from 'react-select/creatable';
import {ActionMeta, OnChangeValue} from 'react-select';
import Select from 'react-select';

export type SelectTypeString = {
    value: string;
    label: string;
    extent:number[];

};

export type Foerdernehmertype = {
    foerdernehmer: string;
    name: string;
    datum: string;
};

type Props = {
    possibleOptions: SelectTypeString[],
    selectedOptoin: SelectTypeString,
    saveChanges: (newValue:string) => void,
    mode:string


};
type State = {

    selectedvalue:SelectTypeString;
}

export default class InputSelectString extends React.Component<PropsWithChildren<Props>, State> {
    constructor(props: Props) {
        super(props);

this.state={
    selectedvalue:props.selectedOptoin
        }
    }

    HandleChange(
        newValue: OnChangeValue<SelectTypeString, false>,
        actionMeta: ActionMeta<SelectTypeString>
    ) {


        if(newValue) {
            this.props.saveChanges(newValue.value);
            this.setState({
                selectedvalue:newValue
            });
        }

    }

    render() {
        let classname:string;
        classname="";
        if(this.props.mode==="BE")
            classname="dropdownboxbe";
        return (
            <div style={{display:"flex", alignItems:"center", flexWrap:"wrap"}}>
                <span style={{marginRight:"5px", fontWeight:"bold"}}>Meine Gemeinde  </span>
                <div className="dropdownbox-wrapper">
                    <Select className="dropdownbox"
                            menuPlacement="auto"
                            menuPosition="fixed"
                            value={this.state.selectedvalue}
                            onChange={(newValue, actionMeta) => this.HandleChange(newValue, actionMeta)}
                            options={this.props.possibleOptions}
                    />
                </div>
            </div>

        );
    }


}